export const GET_IMAGE_DATA_REQUEST = 'imageStore/GET_IMAGE_DATA_REQUEST';
export const GET_IMAGE_DATA_SUCCESS = 'imageStore/GET_IMAGE_DATA_SUCCESS';
export const GET_IMAGE_DATA_FAILURE = 'imageStore/GET_IMAGE_DATA_FAILURE';